import React, { useCallback } from 'react'
import store from '@/redux/store'
import request from '@/modules/base/util/request'
import settingsConfig from '@/modules/settings/config'
import UpgradeModal from '@/modules/base/components/modal/upgrade-modal/upgrade-modal'
import UpgradeModalV2 from '@/modules/base/components/modal/upgrade-modal-v2/upgrade-modal'
import SubscriptionService from '@/modules/base/components/subscription/subscriptionService'
import { groupBy } from 'lodash'
import { isMeinBuero } from '@/utils/build-env'
import { UNSAFE_renderElement as renderElement, useGlobalPortal } from '@/hooks/useGlobalPortal'

const isMeinbuero = isMeinBuero()

export const useUpgradeModal = () => {
  const renderElement = useGlobalPortal()
  return useCallback((options = {}) => internalOpenUpgradeModal(renderElement, options), [])
}

// eslint-disable-next-line camelcase
export const UNSAFE_openUpgradeModal = (options = {}) => {
  internalOpenUpgradeModal(renderElement, options)
}

const internalOpenUpgradeModal = (renderElement, options = {}) => {
  const subscriptionDetails = store.getState()?.subscription?.details
  const onlyOneTrialSubscription = subscriptionDetails?.subscriptions?.length === 1 && subscriptionDetails.subscriptions[0].isTrial
  const typeOfSubscription = onlyOneTrialSubscription ? subscriptionDetails?.subscriptions[0]?.typeOfSubscription : null
  const forceType = (isMeinBuero && typeOfSubscription) || options.forceType

  const {
    actualMarketplaceId,
    subscriptionChange = false,
    trialExpired = false,
    limitReached = '',
    onUpgraded = () => {},
    onClose,
    subscriptionType = typeOfSubscription,
    activeSubscription,
    overrideTexts = {},
    skipPayment = false,
    skipSubscriptionSelection = false,
    preSelectedSubscription = {},
    preSelectedPeriod = null,
    includeModules = true,
    showAllModules = false,
    enableItemsFromStorage = false,
    addNextUpgradeToCart = false,
    modulesToAdd = [],
    startAtAddons = false,
  } = options

  const renderComponent = (data = null, groupedSubscriptionTypes = []) => {
    renderElement((closeModal) => (
      <>
        {!isMeinbuero
          ? <UpgradeModalV2
            open={true}
            activeSubscriptions={subscriptionDetails.subscriptions}
            preSelectedSubscription={activeSubscription}
            preSelectedPeriod={preSelectedPeriod}
            preSelectedSubscriptionType={options.subscriptionType}
            trialExpired={trialExpired}
            includeModules={includeModules}
            onUpgraded={onUpgraded}
            enableItemsFromStorage={enableItemsFromStorage}
            showAllModules={showAllModules}
            addNextUpgradeToCart={addNextUpgradeToCart}
            modulesToAdd={modulesToAdd}
            startAtAddons={startAtAddons}
            onClose={() => {
              closeModal()
              onClose && onClose()
            }}
          />
          : <UpgradeModal
            open={true}
            data={data}
            actualMarketplaceId={actualMarketplaceId}
            overrideTexts={overrideTexts}
            subscriptionType={isMeinbuero && !forceType ? null : subscriptionType}
            activeSubscription={activeSubscription}
            subscriptionChange={subscriptionChange}
            groupedSubscriptionTypes={groupedSubscriptionTypes}
            trialExpired={trialExpired}
            limitReached={limitReached}
            onUpgraded={onUpgraded}
            skipPayment={skipPayment}
            skipSubscriptionSelection={skipSubscriptionSelection}
            preSelectedSubscription={preSelectedSubscription}
            addNextUpgradeToCart={addNextUpgradeToCart}
            onClose={() => {
              closeModal()
              onClose && onClose()
            }} />
        }
      </>
    ))
  }

  const handleReponse = (groupedSubscriptionTypes) => {
    if (subscriptionChange) {
      const { subscription: { details: { subscriptions } } } = store.getState()
      if (subscriptions?.length) {
        return request(settingsConfig.getSubscriptionBillingData(subscriptions[0].id), { auth: true })
          .then((response) => {
            const { body: { data } } = response
            renderComponent(data, groupedSubscriptionTypes)
          })
      }
    } else renderComponent(null, groupedSubscriptionTypes)
  }

  if (isMeinbuero) {
    SubscriptionService.getProductsMbo().then(res => handleReponse(res.data))
  } else {
    SubscriptionService.getWebSubscriptionTypes(subscriptionType).then((body) => {
      const { data: subTypes } = body
      const groupedSubscriptionTypes = groupBy(subTypes, 'type')
      handleReponse(groupedSubscriptionTypes)
    })
  }
}
